"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

var _DragHandle = _interopRequireDefault(require("@insided/deprecated-preact-components/control/DragHandle"));

var _Checkbox = _interopRequireDefault(require("@insided/shared/uikit/Checkbox"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _reactSortableHoc = require("react-sortable-hoc");

var _classnames = _interopRequireDefault(require("classnames"));

var _CategorySelection = _interopRequireDefault(require("@insided/destination/modules/Navigation/shared/CategorySelection"));

var _ContentTypeSelection = _interopRequireDefault(require("@insided/destination/modules/Navigation/widget-dynamic-content/ContentTypeSelection"));

var _contentType = require("@insided/shared/utils/contentType");

var _ProductAreasDropdown = _interopRequireDefault(require("@insided/shared/modules/ProductAreas/ProductAreasDropdown"));

var _productAreas = require("@insided/shared/utils/productAreas");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*
  This widget is used for the component in design https://www.figma.com/design/SphaXXyXe21fZaLIre6sLj/Multi-product-experience-(2024)?node-id=3292-27877&t=t6Am3lqcOFaAkmA5-0
  Mega menu also has similar implementation and probably there will be more coming
  Be aware of specific implementation and i
*/
var CustomLi = function CustomLi(props) {
  return (0, _preact.h)("li", (0, _extends2.default)({}, props, {
    className: (0, _classnames.default)(props.className)
  }));
};

var SortableItem = (0, _reactSortableHoc.SortableElement)(CustomLi);
var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref) {
  var children = _ref.children;
  return (0, _preact.h)("ul", {
    className: "sortable-navigation-link-list"
  }, children);
});

function getShouldShowCategorySelection(item) {
  var selectedContentTypes = item.selectedContentTypes,
      isCustom = item.isCustom;
  if (!isCustom) return false;
  if (!selectedContentTypes) return false;
  var isContentTypeConversationArticleOrQuestionSelected = selectedContentTypes.includes(_contentType.CONTENT_TYPE_CONVERSATION) || selectedContentTypes.includes(_contentType.CONTENT_TYPE_ARTICLE) || selectedContentTypes.includes(_contentType.CONTENT_TYPE_QUESTION);
  var isContentTypeProductUpdateOrIdeaSelected = selectedContentTypes.includes(_contentType.CONTENT_TYPE_PRODUCT_UPDATE) || selectedContentTypes.includes(_contentType.CONTENT_TYPE_IDEA);
  return isContentTypeConversationArticleOrQuestionSelected && !isContentTypeProductUpdateOrIdeaSelected;
}

function getShouldShowProductAreasSelection(item) {
  var selectedContentTypes = item.selectedContentTypes,
      isCustom = item.isCustom;
  if (!isCustom) return false;
  if (!selectedContentTypes) return false;
  return selectedContentTypes.every(function (type) {
    return type === _contentType.CONTENT_TYPE_PRODUCT_UPDATE || type === _contentType.CONTENT_TYPE_IDEA;
  });
}

var SortableNavigationLinks = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SortableNavigationLinks, _Component);

  var _super = _createSuper(SortableNavigationLinks);

  function SortableNavigationLinks() {
    var _this;

    (0, _classCallCheck2.default)(this, SortableNavigationLinks);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderInputGroup", function (field, idx, value, placeholder) {
      return (0, _preact.h)(_InputGroup.default, {
        name: field,
        placeholder: placeholder,
        type: "text",
        onChange: function onChange(e) {
          var _this$props$onItemUrl, _this$props;

          field === 'name' ? _this.props.onItemNameChanged(idx, e.target.value) : (_this$props$onItemUrl = (_this$props = _this.props).onItemUrlChanged) === null || _this$props$onItemUrl === void 0 ? void 0 : _this$props$onItemUrl.call(_this$props, idx, e.target.value);
        },
        value: value
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderItemControls", function (item, idx) {
      var showLabelsOnItems = _this.props.showLabelsOnItems;
      var shouldShowRemoveButton = item.key === 'custom' || item.isCustom;
      return (0, _preact.h)("div", {
        className: "sortable-navigation-links-configurator-actions"
      }, showLabelsOnItems && (0, _preact.h)("span", {
        className: "sortable-navigation-links-configurator-item-label"
      }, item.isCustom ? 'CUSTOM' : 'DEFAULT'), item.key !== 'spaces' && (0, _preact.h)("button", {
        tabIndex: 0,
        className: "sortable-navigation-links-configurator-visibility",
        onClick: function onClick() {
          return _this.props.onItemVisibilityChanged(idx);
        }
      }, (0, _preact.h)(_assets.default, {
        color: "#6B707E",
        icon: item.visibility ? 'eye' : 'eye-cross',
        width: 18,
        height: 18
      })), shouldShowRemoveButton && (0, _preact.h)("button", {
        tabIndex: 0,
        className: "sortable-navigation-links-configurator-delete",
        onClick: function onClick() {
          var _this$props$onItemRem, _this$props2;

          return (_this$props$onItemRem = (_this$props2 = _this.props).onItemRemoved) === null || _this$props$onItemRem === void 0 ? void 0 : _this$props$onItemRem.call(_this$props2, idx);
        }
      }, (0, _preact.h)(_assets.default, {
        icon: "trash",
        color: "#6B707E",
        customClass: "sortable-navigation-links-configurator-trash",
        width: 18,
        height: 18
      })));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderItem", function (item, idx) {
      var _item$selectedProduct, _this$props$productAr, _item$selectedContent, _item$selectedCategor;

      var selectedProductAreas = (0, _productAreas.getSelectedProductAreas)((_item$selectedProduct = item.selectedProductAreaIds) !== null && _item$selectedProduct !== void 0 ? _item$selectedProduct : [], (0, _productAreas.getNormalizedPAList)((_this$props$productAr = _this.props.productAreasList) !== null && _this$props$productAr !== void 0 ? _this$props$productAr : []));
      return (0, _preact.h)(SortableItem, {
        key: item.key,
        index: idx,
        className: "sortable-navigation-link"
      }, (0, _preact.h)("div", {
        className: "sortable-navigation-links-configurator"
      }, (0, _preact.h)("div", {
        className: "sortable-navigation-links-configurator-title"
      }, (0, _preact.h)("span", {
        className: "sortable-navigation-links-configurator-title-text"
      }, (0, _preact.h)(_DragHandle.default, null), item.isCustom ? 'Custom' : item.key), _this.renderItemControls(item, idx)), _this.renderInputGroup('name', idx, item.name, 'Custom name'), item.isCustom && (0, _preact.h)("div", {
        className: "sortable-navigation-links-configurator-custom-item-filters"
      }, (0, _preact.h)(_ContentTypeSelection.default, {
        selectedContentTypes: (_item$selectedContent = item.selectedContentTypes) !== null && _item$selectedContent !== void 0 ? _item$selectedContent : [],
        onChange: function onChange(newSelectedContentTypes) {
          var _this$props$onItemCon, _this$props3;

          return (_this$props$onItemCon = (_this$props3 = _this.props).onItemContentTypesChanged) === null || _this$props$onItemCon === void 0 ? void 0 : _this$props$onItemCon.call(_this$props3, idx, newSelectedContentTypes);
        }
      }), _this.props.categoriesList && (0, _preact.h)(_CategorySelection.default, {
        categoriesV2: _this.props.categoriesList,
        selectedCategories: (_item$selectedCategor = item.selectedCategories) !== null && _item$selectedCategor !== void 0 ? _item$selectedCategor : [],
        onChangeSend: function onChangeSend(newCategoryList) {
          var _this$props$onItemCat, _this$props4;

          return (_this$props$onItemCat = (_this$props4 = _this.props).onItemCategoriesChanged) === null || _this$props$onItemCat === void 0 ? void 0 : _this$props$onItemCat.call(_this$props4, idx, newCategoryList);
        }
      }), _this.props.productAreasList && (0, _preact.h)(_ProductAreasDropdown.default, {
        displaySelectedItemsBelow: true,
        onUpdateProductAreas: function onUpdateProductAreas(newSelectedProductAreas) {
          var _this$props$onItemPro, _this$props5;

          return (_this$props$onItemPro = (_this$props5 = _this.props).onItemProductAreasChanged) === null || _this$props$onItemPro === void 0 ? void 0 : _this$props$onItemPro.call(_this$props5, idx, newSelectedProductAreas);
        },
        selectedProductAreas: selectedProductAreas,
        productAreasV2: _this.props.productAreasList,
        closeOnDropdownClick: false,
        showLabel: true
      })), item.key === 'custom' && (0, _preact.h)("div", null, _this.renderInputGroup('url', idx, item.url, 'URL'), _this.props.canItemOpenInNewTab && (0, _preact.h)(_Checkbox.default, {
        label: "Open in new tab",
        onUpdate: function onUpdate() {
          var _this$props$onItemExt, _this$props6;

          return (_this$props$onItemExt = (_this$props6 = _this.props).onItemExternalChanged) === null || _this$props$onItemExt === void 0 ? void 0 : _this$props$onItemExt.call(_this$props6, idx);
        },
        checked: !!item.external
      })), item.categorySlot));
    });
    return _this;
  }

  (0, _createClass2.default)(SortableNavigationLinks, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props7 = this.props,
          items = _this$props7.items,
          canAddCustomLink = _this$props7.canAddCustomLink,
          onItemUpdated = _this$props7.onItemUpdated,
          onAddCustomLink = _this$props7.onAddCustomLink;
      return (0, _preact.h)("div", {
        className: "navigation_links-list"
      }, (0, _preact.h)(SortableList, {
        useDragHandle: true,
        onSortEnd: function onSortEnd(_ref2) {
          var oldIndex = _ref2.oldIndex,
              newIndex = _ref2.newIndex;
          return onItemUpdated(oldIndex, newIndex);
        }
      }, items.map(function (item, idx) {
        return _this2.renderItem(item, idx);
      })), canAddCustomLink && (0, _preact.h)(_buttonControl.default, {
        newStyle: true,
        variant: "secondary",
        title: "Add custom link",
        onClick: onAddCustomLink
      }));
    }
  }]);
  return SortableNavigationLinks;
}(_preact.Component);

var _default = SortableNavigationLinks;
exports.default = _default;